// ** Redux Imports
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { challenges } from '../../../../APIRoutes'
import axiosRequest from '../../../../APIRoutes/axiosCall'
export const getChallenges = createAsyncThunk('adminChallenges/getChallenges', async () => {
  const response = await axiosRequest.get(challenges.CLINIC_CHALLENGES)
  return { data: response?.data?.data }
})

export const setChallenges = createAsyncThunk('adminChallenges/setChallenges', async (data) => {
  return { data }
})

export const addChallenge = createAsyncThunk('adminChallenges/addChallenge', async (data, { dispatch }) => {
  const response = await axiosRequest.post(challenges.CLINIC_ADD_CHALLENGE, data)
  dispatch(getChallenges())
  return { status: response?.data?.status, message: response?.data?.message }
})

export const updateChallenge = createAsyncThunk('adminChallenges/updateChallenge', async (data, { dispatch }) => {
  const response = await axiosRequest.post(challenges.CLINIC_EDIT_CHALLENGE, data)
  dispatch(getChallenges())
  return { status: response?.data?.status, message: response?.data?.message }
})

export const challengeDetail = createAsyncThunk('adminChallenges/challengeDetail', async (id) => {
  console.log('challenge detail id', id)
  const response = await axiosRequest.post(challenges.CLINIC_CHALLENGE_DETAIL, { id })
  console.log('challenge detail response', response.data)
  return {
    challengeDetail: response?.data?.data ?? {},
    comments: response?.data?.comments ?? [],
    participants: response?.data?.participants ?? []
  }
})

export const deleteChallenge = createAsyncThunk('adminChallenges/deleteChallenge', async (id) => {
  const response = await axiosRequest.post(challenges.CLINIC_DELETE_CHALLENGE, { id })
  return { id, status: response.data?.status }
})

// CHALLENGE CATEGORIES
export const getCategories = createAsyncThunk('adminChallenges/getCategories', async () => {
  const response = await axiosRequest.get(challenges.ADMIN_CHALLENGE_CATEGORIES)
  return { data: response?.data?.data ?? [] }
})

export const setCategories = createAsyncThunk('adminChallenges/setCategories', async (data) => {
  return { data }
})

export const challengesSlice = createSlice({
  name: 'adminChallenges',
  initialState: {
    params: {},
    loading: true,
    data: [],
    challengeDetail: {},
    categories: []
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getChallenges.fulfilled, (state, { payload }) => {
        state.params = payload?.params ?? {}
        state.data = payload?.data ?? []
        state.loading = false
      })
      .addCase(setChallenges.fulfilled, (state, { payload }) => {
        state.data = payload?.data ?? []
      })
      .addCase(addChallenge.fulfilled, (state, { payload }) => {
        console.log(`CREATED CHALLENGE ${payload?.status}`)
        state.status = payload?.status ?? []
      })
      .addCase(getChallenges.rejected, (state) => {
        console.log("===rejected===")
        state.loading = false
      })
      .addCase(getChallenges.pending, (state) => {
        console.log("===pending===")
        state.loading = true
      })
      .addCase(updateChallenge.fulfilled, (state, { payload }) => {
        console.log(`UPDATED CHALLENGE ${payload?.status}`)
      })
      .addCase(challengeDetail.fulfilled, (state, { payload }) => {
        state.challengeDetail = payload?.data
        state.comments = payload?.comments
        state.participants = payload?.participants
      })
      .addCase(deleteChallenge.fulfilled, (state, { payload }) => {
        console.log(`DELETED CHALLENGE ID ${payload?.id}`)
      })
      .addCase(getCategories.fulfilled, (state, { payload }) => {
        state.categories = payload?.data ?? []
      })
      .addCase(setCategories.fulfilled, (state, { payload }) => {
        state.categories = payload?.data ?? []
      })
  }
})

export default challengesSlice.reducer
